import { Link, NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { addItem, removeItem } from '../../reducetool/features/cardSlice';
import { toast } from "react-toastify";
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import { Helmet } from 'react-helmet';

import { subStringProdDescription, subStringProdTitle } from "../../constants/subStringUtils";
import Slider from "react-slick";
import "slick-carousel"; // Ensure slick-carousel is imported
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";





const ProductDetail = () => {

  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4, // Default for large screens (you can adjust this for desktop)
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // Tablet view, for example
        settings: {
          slidesToShow: 3, // 3 items visible for tablet screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // Mobile view
        settings: {
          slidesToShow: 2.5, // 2.5 items visible on mobile
          slidesToScroll: 1,
          centerMode: true, // Optional: It makes the center item stand out
          centerPadding: "10px", // Optional: Adds some space around the center item
        },
      },
      {
        breakpoint: 480, // Small mobile screens
        settings: {
          slidesToShow: 2, // 2 items visible on very small screens
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { slug, prodId } = useParams(); // we’ll use only ID to fetch
  const location = useLocation();
  const navigate = useNavigate();
  const [itemData, setItemData] = useState({});
  const [multipleItemimages, setMultipleItemimages] = useState([]);
  const dispatch = useDispatch();
  const shoppingCart = useSelector(state => state.cardState);
  const [starValue, setStarValue] = useState(0);
  const [productReview, setProductReview] = useState("")
  const authData = useSelector(state => state.authState);
  const [productReviewList, setProductReviewList] = useState([])
  const [reviewErrorMessage, setReviewErrorMessage] = useState({})
  const [relatedProductList, setRelatedProductList] = useState([])

  useEffect(() => {
    if (itemData) {
      const correctSlug = itemData.product_slug;
      if (slug !== correctSlug) {
        navigate(`/product-detail/${correctSlug}/${itemData.id}`, { replace: true });
      }
    }
  }, [itemData]);

  const getItemData = async (productId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/ProductMaster/productDetail?productId=${productId}`, config)
      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors)
      }

      if (response.status === true) {
        setItemData(response.productMasterDataByID)
        setMultipleItemimages(response.productMasterDataByID.productMultipleImageTransMaster ? response.productMasterDataByID.productMultipleImageTransMaster : [])
        setProductReviewList(response.productMasterDataByID.reviewMaster ? response.productMasterDataByID.reviewMaster : []);

      }
      else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  };

  const getRelatedProduct = async () => {

    try {

      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/ProductMaster/relatedProduct?subcategoryId=${itemData.product_sub_category_id}&productId=${itemData.id}`, config)
      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors)
      }

      if (response.status === true) {
        console.log(response, "RELATED");
        setRelatedProductList(response.productMasterData)

      }
      else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  }

  useEffect(() => {
    if (!prodId || isNaN(prodId)) return;
    getItemData(prodId);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [prodId]);

  useEffect(() => {
    if (itemData.id && itemData.product_sub_category_id) {
      getRelatedProduct();
    }
  }, [itemData])



  //const totalQty = shoppingCart ? (shoppingCart.items.find(product => product.id === itemData.id)?.productQty || 0) : 0;

  const createAddToCardData = async (product) => {
    try {

      const response = await apiService.get(`/api/AddToCartMaster/AddToCartOneItem?itemId=${product.id}`);

      if (response.response && response.response.data.errors) {
        console.log(response.response?.data?.errors)
      }

      if (response.status === true) {
        console.log(response.message)
      }
      else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  }


  const handleAddToCart = async () => {
    const updatedProduct = { ...itemData, product_id: itemData.id };
    delete updatedProduct.id;

    if (authData.login) {
      createAddToCardData(itemData);
    }

    dispatch(addItem(updatedProduct));
    toast.success("Great choice! The product is now added to your cart.")
    // if (totalQty === 0) {
    //   await dispatch(addItem(itemData));
    // }
    // navigate("/Cart")
  }

  const validation = () => {
    let errorMessage = {};

    if (starValue === 0) {
      errorMessage.starValue = 'Please select a rating.';
    }

    if (!productReview) {
      errorMessage.productReview = 'Please write the review.';
    }

    setReviewErrorMessage(errorMessage);
    const isValid = Object.keys(errorMessage).length === 0;
    return isValid;
  };

  const reviewSubmit = async () => {
    try {

      const isValid = await validation();
      if (!isValid) {
        return
      }

      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      let params = {
        rating_stars: starValue,
        user_id: authData.user_id,
        product_id: itemData.id,
        product_review: productReview,
      }

      const response = await apiService.post(`/api/ReviewMaster/create`, params, config)
      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors)
      }

      if (response.status === true) {
        toast.success("Review posted successfully!");
        setStarValue(0);
        setProductReview("")
        getItemData(prodId)
      }
      else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  }

  const calculateAverageRating = (reviewMaster) => {

    if (!reviewMaster || reviewMaster.length === 0) {
      return 0;
    }

    const ratings = reviewMaster.map(review => review.rating_stars);
    const filteredRatings = ratings.filter(rating => rating != null);

    if (filteredRatings.length === 0) {
      return 0; // Return 0 if there are no valid ratings
    }

    const sum = filteredRatings.reduce((total, rating) => total + rating, 0);
    const averageRating = sum / filteredRatings.length;

    let roundedRating = Math.floor(averageRating); // Round down by default
    if (averageRating - Math.floor(averageRating) >= 0.5) {
      roundedRating++;
    }

    return roundedRating;
  };

  let averageRating = calculateAverageRating(productReviewList)

  // const hanldeProductDetail = (productId) => {
  //   let selectedItem = relatedProductList.find(item => item.id === productId);
  //   navigate("/ProductDetail", { state: { productId: selectedItem.id, subcategoryName: selectedItem.product_sub_category } });
  // }

  const handleProductDetail = (productId) => {
    const selectedItem = relatedProductList.find(item => item.id === productId);
    if (!selectedItem) {
      console.warn('Product not found');
      return;
    }
    const url = `/product-detail/${selectedItem.product_slug}/${selectedItem.id}`;
    navigate(url);
  };



  return (
    <>
      <Helmet>
        <title>{itemData.product_meta_title}</title>
        <meta name="description" content={`${itemData.product_meta_desc} Powered by Shivkms`} />
        <meta name="keywords" content={`${itemData?.product_meta_keyword ? itemData.product_meta_keyword + ', ' : '' }Shivkms, Shiv Kirpa Multi Solution`}/>
        <meta property="og:title" content={itemData.product_meta_title} />
        <meta property="og:description" content={itemData.product_meta_desc} />
        <meta property="og:image" content={process.env.REACT_APP_API_BASE_URL + itemData.img_url} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={itemData.product_meta_title} />
        <link rel="canonical" href={`${window.location.origin}/product/${itemData.slug}`} />
      </Helmet>
      {/* Breadcrumb Section Start */}
      <section className="breadscrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadscrumb-contain">
                <h2>{itemData.product_title}</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="fa-solid fa-house" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Product Detail Page
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Breadcrumb Section End */}

      {/* Product Left Sidebar Start */}
      <section className="product-section p-2">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 wow fadeInUp">
              <div className="row g-4">

                <div className="col-xl-6 wow fadeInUp bg-white p-5">
                  <div className="product-left-box">
                    <div className="row g-2">

                      {/* // show multiple image  */}

                      <div className="col-xxl-12 col-lg-12 col-md-2 order-xxl-1 order-lg-2 order-md-1 border-right">
                        <div className="left-slider-image-2 text-center left-slider no-arrow slick-top">
                          <img
                            style={{ width: "auto", height: 350, margin: 2 }}
                            src={process.env.REACT_APP_API_BASE_URL + itemData.img_url}
                            className="img-fluid  lazyload"
                            alt=""
                          />
                          {/* {multipleItemimages.map((imagePath, index) => (
                            <div>
                              <div className="sidebar-image">
                                <img
                                  style={{ width: 420, height: 420, margin: 2 }}
                                  src={imagePath.img_url}
                                  className="img-fluid  lazyload"
                                  alt=""
                                />
                              </div>
                            </div>
                          ))}*/}


                        </div>
                      </div>



                    </div>
                  </div>
                </div>
                <div className="col-xl-6 wow fadeInUp bg-white p-5" data-wow-delay="0.1s">
                  <div className="right-box-contain ">


                    {itemData.strike_disc_per > 0 && <h6 className="offer-top">{Math.round(itemData.strike_disc_per)} % OFF</h6>}
                    <h2 className="name">{itemData.product_title}</h2>
                    <div className="col-xl-12">

                      <div className='mb-2'>
                        <Box sx={{ '& > legend': { mt: 2 }, }}>
                          <Rating name="read-only" value={averageRating} readOnly />
                        </Box>
                        <h6>{averageRating} out of 5 ({productReviewList.length} reviews)</h6>
                      </div>
                      {/* <div className="review-title">
                               <h4 className="fw-500">Product Rating</h4>
                             </div> */}
                    </div>

                    <div className="procuct-contain inter-font">
                      <p>
                        {itemData.product_description}
                      </p>
                      {/* <div dangerouslySetInnerHTML={{ __html: itemData.product_content }} className='editor'></div> */}

                    </div>
                    {/* <div className="product-packege">
                      <div className="product-title">
                        <h4>Weight</h4>
                      </div>
                      <ul className="select-packege">
                        <li>
                          <a href="javascript:void(0)" className="active">
                            1/2 KG
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">1 KG</a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">1.5 KG</a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">Red Roses</a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">With Pink Roses</a>
                        </li>
                      </ul>
                    </div> */}
                    <div
                      className="time deal-timer product-deal-timer mx-md-0 mx-auto"
                      id="clockdiv-1"
                      data-hours={1}
                      data-minutes={2}
                      data-seconds={3}
                    >
                      {/* <div className="product-title">
                        <h4>Hurry up! Sale would End Soon</h4>
                      </div> */}

                    </div>
                    <div className="price-rating">
                      <h3 className="theme-color price">
                        Rs {itemData.sp_after_tax}<del className="text-content"> Rs {itemData.strike_sp}</del>
                        {itemData.strike_disc_per > 0 && <span className="offer text-danger text-end">({Math.round(itemData.strike_disc_per)}% off)</span>}
                      </h3>

                      {/*<div className="product-rating custom-rate">
                        
                       <ul className="rating">
                          <li>
                            <i data-feather="star" className="fill" />
                          </li>
                          <li>
                            <i data-feather="star" className="fill" />
                          </li>
                          <li>
                            <i data-feather="star" className="fill" />
                          </li>
                          <li>
                            <i data-feather="star" className="fill" />
                          </li>
                          <li>
                            <i data-feather="star" />
                          </li>
                        </ul> 
                       <span className="review">23 Customer Review</span> 
                      </div>*/}
                    </div>
                    <div className="note-box product-packege">


                      <button
                        type='button'
                        onClick={() => handleAddToCart()}
                        className="btn btn-md theme-bg-color cart-button text-white w-100"
                      >
                        <i className="fa fa-shopping-cart me-2"></i> Add To Cart
                      </button>
                    </div>
                    {/* <div className="buy-box">
                      <a href="wishlist.html">
                        <i data-feather="heart" />
                        <span>Add To Wishlist</span>
                      </a>
                      <a href="compare.html">
                        <i data-feather="shuffle" />
                        <span>Add To Compare</span>
                      </a>
                    </div>
                    <div className="pickup-box">
                      <div className="product-title">
                        <h4>Store Information</h4>
                      </div>
                      <div className="pickup-detail">
                        <h4 className="text-content">
                          Lollipop cake chocolate chocolate cake dessert jujubes.
                          Shortbread sugar plum dessert powder cookie sweet brownie.
                        </h4>
                      </div>
                      <div className="product-info">
                        <ul className="product-info-list product-info-list-2">
                          <li>
                            Type : <a href="javascript:void(0)">Black Forest</a>
                          </li>
                          <li>
                            SKU : <a href="javascript:void(0)">SDFVW65467</a>
                          </li>
                          <li>
                            MFG : <a href="javascript:void(0)">Jun 4, 2022</a>
                          </li>
                          <li>
                            Stock : <a href="javascript:void(0)">2 Items Left</a>
                          </li>
                          <li>
                            Tags : <a href="javascript:void(0)">Cake,</a>{" "}
                            <a href="javascript:void(0)">Backery</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="paymnet-option">
                      <div className="product-title">
                        <h4>Guaranteed Safe Checkout</h4>
                      </div>
                      <ul>
                        <li>
                          <a href="javascript:void(0)">
                            <img
                              src="../assets/images/product/payment/1.svg"
                              className=" lazyload"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">
                            <img
                              src="../assets/images/product/payment/2.svg"
                              className=" lazyload"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">
                            <img
                              src="../assets/images/product/payment/3.svg"
                              className=" lazyload"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">
                            <img
                              src="../assets/images/product/payment/4.svg"
                              className=" lazyload"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">
                            <img
                              src="../assets/images/product/payment/5.svg"
                              className=" lazyload"
                              alt=""
                            />
                          </a>
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
                <div className="col-xl-12 wow fadeInUp  bg-white p-2">
                  <div className="product-section-box mt-0">
                    <ul
                      className="nav nav-tabs nav-fill custom-nav"
                      id="myTab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="description-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#description"
                          type="button"
                          role="tab"
                          aria-controls="description"
                          aria-selected="true"
                        >
                          About the Product
                        </button>
                      </li>
                      {/* <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="info-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#info"
                          type="button"
                          role="tab"
                          aria-controls="info"
                          aria-selected="false"
                        >
                          Additional info
                        </button>
                      </li> */}
                      {/* <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="care-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#care"
                          type="button"
                          role="tab"
                          aria-controls="care"
                          aria-selected="false"
                        >
                          Care Instuctions
                        </button>
                      </li> */}
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="review-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#review"
                          type="button"
                          role="tab"
                          aria-controls="review"
                          aria-selected="false"
                        >
                          Customer Reviews
                        </button>
                      </li>
                    </ul>

                    <div className="tab-content custom-tab p-3" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="description"
                        role="tabpanel"
                        aria-labelledby="description-tab"
                      >
                        <div className="product-description">
                          <div className="nav-desh inter-font">

                            <div dangerouslySetInnerHTML={{ __html: itemData.product_content }} className='editor'></div>
                            {itemData.product_content?.trim() === "" && <p>Description not found.... Please try again later</p>}
                          </div>

                        </div>
                      </div>

                      <div
                        className="tab-pane fade"
                        id="review"
                        role="tabpanel"
                        aria-labelledby="review-tab"
                      >
                        <div className="review-box">
                          <div className="row g-4">

                            <div className="col-12">
                              <div className="review-title">
                                <h4 className="fw-500">
                                  Total {productReviewList.length} customer reviews
                                </h4>
                              </div>
                              <div className="review-people">
                                <ul className="review-list">
                                  {
                                    productReviewList.length > 0 ?
                                      productReviewList.map((data) => (
                                        <li>
                                          <div className="people-box">
                                            {/* <div>
                                          <div className="people-image">
                                            <img
                                              src="../assets/images/review/1.jpg"
                                              className="img-fluid  lazyload"
                                              alt=""
                                            />
                                          </div>
                                        </div> */}
                                            <div className="people-comment">
                                              <a
                                                className="name"
                                                href="javascript:void(0)"
                                              >
                                                {data.user_Detail.user_name}
                                              </a>
                                              <div className="date-time">

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                  <Box
                                                    sx={{
                                                      '& > legend': { mt: 2 },
                                                    }}
                                                  >
                                                    <Rating name="read-only" value={data.rating_stars} readOnly />
                                                  </Box>

                                                </div>
                                                <h6 className="text-content">

                                                  <td>{data.created_on ? new Date(data.created_on).toLocaleString() : ""}</td>

                                                </h6>
                                              </div>
                                              <div className="reply">
                                                <p>
                                                  {data.product_review}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </li>
                                      )) : <p>No reviews to show</p>}
 
                                </ul>
                              </div>
                            </div>
                            {authData.login && (
  <div className="col-12 col-md-6">
    <div className="review-title mb-3">
      <h4 className="fw-semibold">Add a Review</h4>
    </div>

    {/* Star Rating */}
    <div className="mb-3">
      <Box>
        <Rating
          name="simple-controlled"
          value={starValue}
          onChange={(event, newValue) => {
            setStarValue(newValue);
          }}
        />
      </Box>
      {reviewErrorMessage.starValue && (
        <div className="text-danger small">{reviewErrorMessage.starValue}</div>
      )}
    </div>

    {/* Textarea for Review */}
    <div className="mb-3">
      <div className="form-floating">
        <textarea
          className="form-control"
          placeholder="Leave a comment here"
          id="floatingTextarea2"
          style={{ height: 150 }}
          value={productReview}
          onChange={(e) => setProductReview(e.target.value)}
        />
        <label htmlFor="floatingTextarea2">Write Your Comment</label>
      </div>
      {reviewErrorMessage.productReview && (
        <div className="text-danger small">{reviewErrorMessage.productReview}</div>
      )}
    </div>

    {/* Submit Button */}
    <div className="mb-3">
      <button
        type="button"
        onClick={reviewSubmit}
        className="btn btn-primary theme-bg-color text-white w-100"
      >
        Submit Review
      </button>
    </div>
  </div>
)}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* Product Left Sidebar End */}
      {/* Releted Product Section Start */}
      <section className="product-list-section section-b-space">
        <div className="container-fluid-lg ">



          <div className="row g-2">
            <div className="col-xl-12 bg-white p-3">
              <div className="title">
                <h2>Related Products</h2>

              </div>

              <div className="section-b-space">


                <div className="category-slider" style={{ backgroundColor: "transparent" }}>
                  {/* Section Heading */}

                  {/* Product Slider */}
                  <Slider {...settings} className="mt-3 mb-5">
                    {relatedProductList.map((product, idx) => (
                      <div key={idx} className="product-box-3 h-100 wow fadeInUp p-2 shadow-sm" style={{ border: "1px solid #eaeaea !important", borderColor: "#c2a57c !important", borderRadius: "none" }}>
                        <div className="product-header position-relative overflow-hidden rounded-3">
                          <div className="product-image">
                            <NavLink
                              to={`/product-detail/${product.product_slug}/${product.id}`} >
                              <img
                                src={process.env.REACT_APP_API_BASE_URL + product.img_url}
                                className="img-fluid lazyloaded transition"
                                alt={product.product_title}
                                style={{ borderRadius: '12px', aspectRatio: '1 / 1' }}
                              />
                            </NavLink>
                          </div>
                        </div>

                        <div className="product-footer mt-3 px-2">
                          <div className="product-detail text-start">
                            <span className="badge bg-light text-dark small mb-1">{product.product_sub_category}</span>
                            <NavLink
                              to={`/product-detail/${product.product_slug}/${product.id}`} >
                              <h5 className="fw-semibold lh-sm text-theme" style={{
                                maxHeight: '4em',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'normal'
                              }}>
                                {subStringProdTitle(product.product_title)}
                              </h5>
                              <p className="text-muted mb-2" style={{
                                                                    display: 'inline-block',
                                                                    width: 'ch',
                                                                    whiteSpace: 'pre-wrap', 
                                                                    overflow: 'hidden',
                                                                    height: '4em', 
                                                                }}>
                                {subStringProdDescription(product.product_description)}...
                              </p>
                            </NavLink>

                            <div className="price-box mt-2 mb-3">
                              <h5 className="price text-dark mb-1">
                                ₹<span className="fw-bold">{product.sp_after_tax}</span>
                                <del className="text-muted ms-2 small">₹{product.strike_sp}</del>
                              </h5>
                              <span className="text-danger small">({Math.round(product.strike_disc_per)}% off)</span>
                            </div>

                            <div className="add-to-cart-box mt-2">
                              <button
                                className="btn add-to-cart-button theme-bg-color text-white w-100 shadow-sm py-2"
                                onClick={() => handleAddToCart(product)}
                              >
                                <i className="fa fa-shopping-cart me-2"></i>Add to Cart
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>

{/* 

                <div className="row row-cols-xxl-5 row-cols-md-4 row-cols-sm-3 row-cols-2 g-sm-4 g-3 no-arrow">

                  {
                    relatedProductList.length > 0 ?
                      relatedProductList.map((data) => (
                        <div>
                          <div
                            className="product-box product-white-bg wow fadeIn"
                            style={{ visibility: "visible", animationName: "fadeIn" }}
                          >
                            <div className="product-image">
                              <a onClick={() => { handleProductDetail(data.id) }}>
                                <img
                                  src={process.env.REACT_APP_API_BASE_URL + data.img_url}
                                  className="img-fluid blur-up lazyloaded"
                                  alt=""
                                />
                              </a>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                              <Box
                                sx={{
                                  '& > legend': { mt: 2 },
                                }}
                              >
                                <Rating name="read-only" value={calculateAverageRating(data?.reviewMaster)} readOnly />
                              </Box>
                            </div>
                            <div className="product-detail">
                              <span className="span-name">{data.product_sub_category}</span>
                              <a href="product-left-thumbnail.html">
                                <h5 className="name" style={{ fontWeight: "bold" }}>
                                  {data.product_title}
                                </h5>
                              </a>

                              <h5 className="price">
                                <span className="theme-color" >Rs{data.sp_after_tax}</span>{" "}
                                <del>Rs{data.strike_sp}</del>
                              </h5>
                            </div>

                            <div className="add-to-cart-box theme-color">
                            <button className="btn btn-add-cart addcart-button text-light theme-bg-color" onClick={() => handleAddToCart(product.id)} >
                              Add to Cart
                            </button>
                          </div> 
                          </div>
                        </div>
                      )) : <p>No related Products to show</p>}
                </div> */}


              </div>

            </div>
          </div>
        </div>
      </section>
      {/* Releted Product Section End */}


    </>
  )
}

export default ProductDetail;